import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  maxleave: 0,
  isfurtureappallowed: false,
  minleavecountforapp: 0,
  notifyinadvanceday: 0,
  notifynotbeforeday: 0,
};
class LeaveUsage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () =>
        this.SetValues(props));
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;
      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        maxleave: InitLeavesPolicy.policy[ParentIndex].maxleave,
        isfurtureappallowed:
          InitLeavesPolicy.policy[ParentIndex].isfurtureappallowed,
        minleavecountforapp:
          InitLeavesPolicy.policy[ParentIndex].minleavecountforapp,
        notifyinadvanceday:
          InitLeavesPolicy.policy[ParentIndex].notifyinadvanceday,
        notifynotbeforeday:
          InitLeavesPolicy.policy[ParentIndex].notifynotbeforeday,
      });
    } else {
      this.setState({ ...ParentState });
    }
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language
        ? this.props.Language.extratimepolicy[key]
        : "",
    });
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "isfurtureappallowed":
        this.setState(
          {
            [name]: arg[0],
            minleavecountforapp: 0,
            notifyinadvanceday: 1,
            notifynotbeforeday: 2,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      maxleave: this.state.maxleave,
      isfurtureappallowed: this.state.isfurtureappallowed,
      minleavecountforapp: this.state.minleavecountforapp,
      notifyinadvanceday: this.state.notifyinadvanceday,
      notifynotbeforeday: this.state.notifynotbeforeday,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max)
        || Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  render() {
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        {/* 4 */}
        <div className="margin-top-20">
          <div className="inner-wrapper opaque">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbEmpConfirmation"
                defaultMessage="Leave usage limits after employee's confirmation"
              />
            </p>
            <span className="floatleft margin-right-16">
              <span className="floatleft margin-top-16">
                <FormattedMessage
                  id="LbAllowMax"
                  defaultMessage="Allow only a maximum of"
                />
              </span>
              <span className="floatleft">
                <InputValues
                  min="0"
                  max="300"
                  field="maxleave"
                  onChange={this.CommonNumberChange.bind(this, "maxleave", 300)}
                  value={this.state.maxleave}
                  defaultvalue={this.state.maxleave}
                />
              </span>
              <span className="floatleft margin-top-16">
                <FormattedMessage
                  id="LbDaysInYear"
                  defaultMessage="days leave in a year"
                />
              </span>
            </span>
          </div>

          <div className="inner-wrapper clear-float opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLimitFutureApplications"
                defaultMessage="Do you want to limit leave applications for future dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", true)}
              aria-expanded={this.state.isfurtureappallowed == true}
            >
              <span>
                {" "}
                <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
              </span>
              {this.state.isfurtureappallowed == true ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isfurtureappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbLeaveDurationGreater"
                  defaultMessage="If leave duration is greater than"
                />
                <InputValues
                  min="0"
                  max="365"
                  field="minleavecountforapp"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "minleavecountforapp",
                    365,
                  )}
                  value={this.state.minleavecountforapp}
                  defaultvalue={this.state.minleavecountforapp}
                />
                <span>days, </span>
                <br />
                <FormattedMessage
                  id="__LbApplicationMustBe"
                  defaultMessage="employee must apply for a leave  atleast"
                />
                <InputValues
                  min="1"
                  max="365"
                  field="notifyinadvanceday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifyinadvanceday",
                    365,
                  )}
                  value={this.state.notifyinadvanceday}
                  defaultvalue={this.state.notifyinadvanceday}
                />
                <span>days in advance,</span>
                <br />
                <FormattedMessage
                  id="__LbButNotEarlier1"
                  defaultMessage="but not earlier than"
                />

                {/* <FormattedMessage
                  id="__LbApplicationMustBe"
                  defaultMessage="days, employee must apply for a leave  atleast"
                />
                <InputValues
                  min="1"
                  max="365"
                  field="notifyinadvanceday"
                  onChange={this.CommonNumberChange.bind(this, "notifyinadvanceday", 365)}
                  value={this.state.notifyinadvanceday}
                  defaultvalue={this.state.notifyinadvanceday}
                />
                days in advance, but not earlier than */}
                <InputValues
                  min={
                    (this.state.notifyinadvanceday
                      && parseInt(this.state.notifyinadvanceday) + 1) || 2
                  }
                  max="365"
                  field="notifynotbeforeday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifynotbeforeday",
                    365,
                  )}
                  value={this.state.notifynotbeforeday}
                  defaultvalue={this.state.notifynotbeforeday || 2}
                />
                <FormattedMessage id="LbDays" defaultMessage="days" />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", false)}
              aria-expanded={this.state.isfurtureappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isfurtureappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveUsage)));
